import React from 'react'

import styles from './Sidebar.module.scss'
import chatbotLogo from 'Images/chatbot_logo.png'

const Brand = () => {
  return (
    <div className={styles.BrandContainer}>
      <img src={chatbotLogo} alt='Chatbot' className={styles.BrandLogo} />
    </div>
  )
}

export default Brand
